export default "__VITE_ASSET__CIm1ebq1__"